/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why isn't a year included as a fixed conversion unit?`)
};

const es_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué un año no se incluye como una unidad de conversión fija?`)
};

const de_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist ein Jahr nicht als feste Umrechnungseinheit enthalten?`)
};

const nl_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is een jaar niet opgenomen als een vaste conversie eenheid?`)
};

const fr_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi une année n'est-elle pas incluse comme unité de conversion fixe ?`)
};

const it_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché un anno non è incluso come unità di conversione fissa?`)
};

const pt_br2_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que um ano não é incluído como uma unidade de conversão fixa?`)
};

const pt_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que um ano não está incluído como uma unidade de conversão fixa?`)
};

const ja_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ年は固定変換単位として含まれていないのですか?`)
};

const zh_uc_time_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq2_q", locale)
	if (locale === "en") return en_uc_time_faq2_q(inputs)
	if (locale === "es") return es_uc_time_faq2_q(inputs)
	if (locale === "de") return de_uc_time_faq2_q(inputs)
	if (locale === "nl") return nl_uc_time_faq2_q(inputs)
	if (locale === "fr") return fr_uc_time_faq2_q(inputs)
	if (locale === "it") return it_uc_time_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq2_q(inputs)
	if (locale === "pt") return pt_uc_time_faq2_q(inputs)
	if (locale === "ja") return ja_uc_time_faq2_q(inputs)
	return zh_uc_time_faq2_q(inputs)
};